"use client";

/**
 * ダッシュボードアイテム表示コンポーネント
 * 表示のみを担当し、クリックやナビゲーション処理は親コンポーネントで実行
 */
export function DashboardSidebarGroupItem({
  name,
  className,
  isDragging,
}: {
  name: string;
  className?: string;
  isDragging?: boolean;
}) {
  return (
    <div
      className={className}
      style={{
        // ドラッグ中はクリック不可にする
        pointerEvents: isDragging ? "none" : "auto",
      }}
    >
      <div className="line-clamp-1 min-w-0" title={name}>
        {name}
      </div>
    </div>
  );
}
